export default "__VITE_ASSET__Bs0iOb8m__"